
import { ActionBarItem } from "@rio-cloud/rio-uikit";
import PackageJson from "../../../package.json";

const VersionInfoBar = () => {
  const showItems = false;

  const items = [
    {
      label: "Análise de eficiência",
      onClick: () => {
        // TODO: Implementar ação
      },
    },
    {
      label: "Tutorial da Recorrência",
      onClick: () => {
        // TODO: Implementar ação
      },
    },
  ];

  return (
    <ActionBarItem>
      <ActionBarItem.Icon>
        <span
          className="icon"
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 24,
            height: 24,
            borderRadius: "50%",
            backgroundColor: "currentColor",
          }}
        >
          <span
            className="text-color-white dark-text-color-dark"
            style={{
              fontSize: 18,
              fontWeight: 700,
              lineHeight: 1,
            }}
          >
            i
          </span>
        </span>

        {showItems && items.length > 0 && (
          <span className="badge badge-primary badge-indicator badge-indicator-pinging">
            {items.length}
          </span>
        )}
      </ActionBarItem.Icon>

      <ActionBarItem.Popover useOffscreen className="padding-0">
       <div className="padding-x-20 padding-top-10 padding-bottom-10 display-flex align-items-center gap-15">
          <span className="text-size-14 text-color-dark">
            Análise de eficiência
          </span>

          <span className="text-size-14 text-color-gray">
            v{PackageJson.version}
          </span>
        </div>

        {showItems && items.length > 0 && (
          <div className="padding-x-20 padding-top-15 padding-bottom-15 display-flex flex-column align-items-start gap-5">
            {items.map((item) => (
              <button
                key={item.label}
                type="button"
                className="text-color-primary text-size-14"
                style={{
                  background: "transparent",
                  border: "none",
                  padding: 0,
                  textAlign: "left",
                  cursor: "pointer",
                  lineHeight: "20px",
                  fontFamily: "inherit",
                  textDecoration: "none",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.textDecoration = "underline";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.textDecoration = "none";
                }}
                onClick={item.onClick}
              >
                {item.label}
              </button>
            ))}
          </div>
        )}
      </ActionBarItem.Popover>
    </ActionBarItem>
  );
};

export default VersionInfoBar;
